

import { createSlice } from '@reduxjs/toolkit';



const initialState = {
     loading: false,
        main_loading: true,
        data: {},
        sites:[],
        main_data: {},
        error: false,
    lastFetched: null,
};

// Try to load from localStorage
const saved = localStorage.getItem('rms_status');
if (saved) {
    try {
        const parsed = JSON.parse(saved);
        initialState.sites = parsed.sites || {};
        initialState.lastFetched = parsed.lastFetched || null;
    } catch (err) {
        console.error('Error parsing localStorage tenant alarm cache:', err);
    }
}

export const RmsStatusSlice = createSlice({
    name:'RmsSTATUS',
    initialState:initialState,
    reducers:{
        RMS_STATUS_FETCH_START:(state)=>{
            state.loading=true
        },
        RMS_STATUS_FETCH_SUCCESS:(state,action)=>{
            state.loading=false
            state.main_loading=false
            state.data=action.payload
            state.sites=action.payload.sites;
             state.lastFetched = Date.now();

            // ✅ Save to localStorage
            localStorage.setItem('rms_status', JSON.stringify({
                sites: action.payload.sites,
                lastFetched: Date.now()
            }));
        },
        RMS_STATUS_FETCH_LOAD_MORE:(state,action)=>{
            state.loading=false
            state.data=action.payload
            state.sites=[...state.sites,...action.payload.sites]
        },
        EDIT_RMS_STATUS_FETCH_SUCCESS: (state, action) => {
            state.loading = false
            const newArray = state.sites.filter(todo => todo.id !==action.payload.id)
             state.sites = [...newArray,action.payload]
        },
        RMS_STATUS_FETCH_ERROR:(state)=>{
            state.error=true
        }
    }
});

export const {RMS_STATUS_FETCH_LOAD_MORE, RMS_STATUS_FETCH_START,RMS_STATUS_FETCH_SUCCESS,RMS_STATUS_FETCH_ERROR,EDIT_RMS_STATUS_FETCH_SUCCESS }=RmsStatusSlice.actions;
export default RmsStatusSlice.reducer;